import Icon from 'zarm/lib/icon';

Icon.defaultProps.prefixCls = 'zw-icon';

export default Icon;
